import React from 'react';
import styles from './Menu.module.css';

// Bạn có thể thay bằng URL hình ảnh thực tế của bạn
 const logo = "/assets/logo/logo.png"; // Logo Smoke Lounge


const formatPrice = (amount, perPerson = false) => {
    const formatted = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    }).format(amount);

    return perPerson ? `${formatted} p.P` : formatted;
};
const MenuComponents = (props) => {
    const {foods,title,menuText,images=[],position = 'right',linkMenu,handleClick,handleOpenLink} = props;
    {/* Phần thông tin giá bên phải */}
    const componentMenu = (
        <div className={styles.rightSection}>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.contentRight}>
                {foods.map((food)=>{
                    return (
                        <div key={food.id} className={styles.priceItem}>
                            <div className={styles.mainInfo}>
                                <h3 className={styles.foodName}>{food.name}</h3>
                                <span className={styles.line}></span>
                                <span className={styles.price}>{ food?.price && formatPrice(food.price, true)} </span>
                            </div>
                            <p className={styles.description}>{food.des}</p>
                        </div>
                    )
                })}
            </div>

        <div className={styles.wrapMenuButton}>
            <button onClick={handleOpenLink} className={styles.menuButton}>
                {menuText}
            </button>
            <button onClick={handleClick} className={styles.menuButton}>
                Tisch reservieren
            </button>
        </div>
        </div>
    )
    return (
        <div className={styles.container}>
            <div className={styles.wrapContainer}>
                {position === "left" && componentMenu}
                {
                    images.map((image)=>{
                        return <div onClick={() =>{
                            if (linkMenu) {
                                window.open(linkMenu, '_blank', 'noopener,noreferrer');
                            }
                        }} className={`${images.length === 1 ? styles.sectionImageOne : styles.sectionImage}`} key={image?.id}>
                            <img src={image?.url} alt={image?.alt} onClick={image?.onClick} className={styles.meatImage}/>
                            <div className={styles.logoOverlay}>
                                <img src={logo} alt="GIRI Logo" className={styles.logo}/>
                            </div>
                        </div>
                    })
                }
                {position === "right" && componentMenu}

            </div>
        </div>
    );
};

export default MenuComponents;